import { useHistory, useLocation } from 'react-router';
import useUserContext from '../../../common/hooks/useUserContext';

const SecurityQuestions = () => {
  const { user } = useUserContext();
  const history = useHistory();
  const location = useLocation();

  if (
    location.pathname !== '/' &&
    !location.pathname.startsWith('/c/') &&
    user.mustAnswerSecurityQuestions
  ) {
    history.push(
      '/c/usersecurityquestion?relyingParty=ELIXHRUI&nodeKey=self_questions&nodeUrl=/usersecurityquestion'
    );
  }
  return null;
};

export default SecurityQuestions;
